<form [formGroup]="form">
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title" style="font-weight: bold">PRODUTOS</h3>
    </div>
    <div class="modal-body">

      <div *ngIf="seguros.length > 0" style="display: flex; flex-direction: column">
        <h3 style="align-self: flex-start; margin-top: 0">Seguros</h3>
        <div class="container-modal" *ngFor="let item of seguros">
          <input
              type="radio"
              [id]="'radioSeguro' + item.id"
              [value]="item.id"
              formControlName="seguroSelecionado">
          <label class="label-modal" [htmlFor]="'radioSeguro' + item.id">
            <p>{{ item.description }}</p>
            <span class="">Custo:<br>{{ item.cost || 0 | currency:'BRL':'symbol' }}</span>
          </label>
        </div>
        <div class="container-modal">
          <input
              type="radio"
              id="radioSeguro0"
              [value]="0"
              formControlName="seguroSelecionado">
          <label class="label-modal" for="radioSeguro0">
            <p>NENHUM</p>
          </label>
        </div>
        <hr>
      </div>

      <div *ngIf="assistencias.length > 0" style="display: flex; flex-direction: column">
        <h3 style="align-self: flex-start; margin-top: 0">Assistências</h3>
        <div class="container-modal" *ngFor="let item of assistencias">
          <input
              type="radio"
              [id]="'radioAssistencia' + item.id"
              [value]="item.id"
              formControlName="assistenciaSelecionado">
          <label class="label-modal" [htmlFor]="'radioAssistencia' + item.id">
            <p>{{ item.description }}</p>
            <span class="">Custo:<br>{{ item.cost || 0 | currency:'BRL':'symbol' }}</span>
          </label>
        </div>
        <div class="container-modal">
          <input
              type="radio"
              id="radioAssistencia0"
              [value]="0"
              formControlName="assistenciaSelecionado">
          <label class="label-modal" for="radioAssistencia0">
            <p>NENHUM</p>
          </label>
        </div>
        <hr>
      </div>

    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="marginT30 form-group">
          <a class="bt-back btn btn-border-orange pull-left" (click)="close()"> Fechar</a>
          <a class="bt-go btn btn-full-orange pull-right" (click)="onClickSalvar()">
            Salvar <em class="fa fa-save"></em>
          </a>
        </div>
      </div>
    </div>
  </div>
</form>
